// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"4fc92b57","232":"f022cb2d","237":"54208c8e","526":"4e9ecaba","787":"08b4253b","872":"375a5d4a"}[chunkId] + ".chunk.js";
};